import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { AddTaskPackComponent } from '../add-task-pack/add-task-pack.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToolbarServiceService } from 'src/app/layout/components/toolbar/toolbar-service.service';
import { WorkflowService } from '@_services/workflow.service';
import { MatSort, Sort } from '@angular/material/sort';
import { SortingBehaviourService } from '@_services/sorting-behaviour.service';
import { HyperlinkNavigationService } from '@_services/hyperlink-navigation.service';

@Component({
  selector: 'app-tasks-pack',
  templateUrl: './tasks-pack.component.html',
  styleUrls: ['./tasks-pack.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TasksPackComponent implements OnInit {
  private _unsubscribeAll$: Subject<void> = new Subject();
  class: any;
  displayedColumns = ['Matter Class', 'Order', 'Default', 'Description'];
  selectedColore: string = 'var(--highlighted-bg-row)';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<any>;
  isLoadingResults: boolean;
  highlightedRows: any;
  SelectedTaskPackRow: any;
  confirmDialogRef: MatDialogRef<any>;
  dialogRef: MatDialogRef<any>;
  sortingDefaultState: any = {};
  sortactive: any;
  sortDirection: any;
  COLOR: any;
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }
  constructor(
    private behaviorService: BehaviorService,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    public _matDialog: MatDialog,
    public toolbarServiceService: ToolbarServiceService,
    private WorkFlow: WorkflowService,
    private SortingbehaviorService: SortingBehaviourService,
    private hyperlinkservice: HyperlinkNavigationService,
    private cd: ChangeDetectorRef,
  ) {
    this.SortingbehaviorService.workflowSorting$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (result) {
          this.sortingDefaultState = result;
          localStorage.setItem('taskworkflow_screen_sorting', JSON.stringify(result));
        } else {
          this.sortingDefaultState = JSON.parse(
            localStorage.getItem('taskworkflow_screen_sorting'),
          );
        }
        this.cd.markForCheck();
      },
    });

    this.hyperlinkservice.setColorSetting();
  }

  ngOnInit(): void {
    if (this.sortingDefaultState) {
      this.sortactive = this.sortingDefaultState.active;
      this.sortDirection = this.sortingDefaultState.direction;
    } else {
      this.sortactive = 'Order';
      this.sortDirection = 'asc';
    }
    this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          this.class = data;
          this.cd.markForCheck();
        },
      });

    this.getAllTaskPack();

    this.behaviorService.ColorSystemSetting$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (data: any) => {
        this.COLOR = data;
        this.cd.markForCheck();
      },
    });
  }

  // This functionis used to get All task packs
  getAllTaskPack() {
    this.isLoadingResults = true;
    let pastData = {
      Action: 'GetData',
      Filters: {
        AllData: true,
      },
    };
    this._mainAPiServiceService
      .getSetData(pastData, 'task-pack')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (res: any) => {
          if (res.CODE == 200 && res.STATUS == 'success') {
            this.dataSource = new MatTableDataSource(res.DATA.RECORDS);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            if (res.DATA.RECORDS[0]) {
              this.SelectedTaskPackRow = res.DATA.RECORDS[0];
              this.highlightedRows = res.DATA.RECORDS[0].TASKPACKGUID;
            }
            setTimeout(() => {
              this.isLoadingResults = false;
              this.cd.markForCheck();
            }, 500);
          }
          this.cd.markForCheck();
        },
        error: (err: any) => {
          this.isLoadingResults = false;
          this.toastr.error(err);
          this.cd.markForCheck();
        },
      });
  }

  editTaskPacks(row: any) {
    this.SelectedTaskPackRow = row;
    this.cd.markForCheck();
  }

  /**
   * This function is used to Add task pack.
   */
  TaskPackAddEdit(headerName: any) {
    this.WorkFlow.TaskPack(headerName, this.SelectedTaskPackRow?.TASKPACKGUID);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  deleteTaskPack() {
    this.WorkFlow.deleteTaskPack(this.SelectedTaskPackRow?.TASKPACKGUID, 'task-pack');
  }

  sortData(sort: Sort) {
    this.SortingbehaviorService.taskWorkflowSorting(sort);
  }
}
